import React from 'react'
import { Grid, CircularProgress } from '@material-ui/core'

const Fetching = () => {
  return (
    <Grid container direction="row" justifyContent="center" spacing={2}>
      <CircularProgress size={24} />
    </Grid>
  )
}

export default Fetching
